import {Component, Input, OnInit} from '@angular/core';
import {MenuItem} from 'src/app/interfaces/global.interface';
import {PAGE_ANIMATIONS} from 'src/app/shared/constants/constants';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  animations: PAGE_ANIMATIONS,
})
export class ContentComponent implements OnInit {
  currentYear: any;
  @Input() hasMenu;
  menuDisplay: MenuItem[];

  constructor(
    // private route:Route,
  ) {
  }

  ngOnInit(): void {
    // this.hasMenu = true; // To be removed
    this.hasMenu == true ? this.menuDisplay = [] :
      this.currentYear = new Date().getFullYear();
  }

  minNavigationRout(event) {
    console.log(event)
  }

  onDeactivate(event) {
    console.log("route deactivate", event);
  }
}
